function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

const Tabs = ({ tabs, activeTab, handleTabClick }) => {
  const renderTabContent = () => {
    const activeTabContent = tabs.find((tab) => tab.id === activeTab);
    return activeTabContent && activeTabContent.content;
  };

  return (
    <div>
      <div className="block">
        <nav className="flex bg-white rounded-lg shadow-sm font-semibold w-fit" aria-label="Tabs">
          {tabs.map((tab, tabIdx) => (
            <button
              onClick={() => handleTabClick(tabIdx)}
              key={tab.name}
              className={classNames(
                tabIdx === activeTab ? 'bg-primary-main text-white rounded-lg' : 'text-kin-text',
                'relative flex flex-row items-center overflow-hidden pt-2.5 pb-2 px-5 text-center text-base',
              )}
              aria-current={tabIdx === activeTab ? 'page' : undefined}>
              {tab.icon ? tab.icon : <></>}
              <span className="leading-[normal]">{tab.name}</span>
            </button>
          ))}
        </nav>
      </div>
      <div className="mt-5">{renderTabContent()}</div>
    </div>
  );
};

export default Tabs;
